function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M14.4 3.368h-3.2V1.684C11.2.75 10.488 0 9.6 0H6.4c-.888 0-1.6.75-1.6 1.684v1.684H1.6c-.888 0-1.592.75-1.592 1.685L0 14.316C0 15.25.712 16 1.6 16h12.8c.888 0 1.6-.75 1.6-1.684V5.053c0-.935-.712-1.685-1.6-1.685zm-4.8 0H6.4V1.684h3.2v1.684z",
  id: "briefcase_svg__a"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "briefcase_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#briefcase_svg__a"
})), React.createElement("use", {
  fill: "currentColor",
  fillRule: "nonzero",
  xlinkHref: "#briefcase_svg__a"
}), React.createElement("g", {
  mask: "url(#briefcase_svg__b)",
  fill: "currentColor"
}, React.createElement("path", {
  d: "M0 0h20v20H0z"
})));

var Briefcase = function Briefcase(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
};

export default Briefcase;